export default __webpack_public_path__ + "e4c53372b51698aceb1abf40e5bc219c.png";